import React, { Component } from 'react';

import GoalContestManager from '../../../managers/GoalContestManager';

export default class DateSlide extends Component {

    constructor(props) {
        super(props);

        let fromDateObj = this.datePiecesFromDateIndex(this.props.fromDate);
        let toDateObj = this.datePiecesFromDateIndex(this.props.toDate);

        this.state = {
            fromYear: fromDateObj.year,
            fromMonth: fromDateObj.month,
            fromDay: fromDateObj.day,
            toYear: toDateObj.year,
            toMonth: toDateObj.month,
            toDay: toDateObj.day,
        }

        this.datePiecesFromDateIndex = this.datePiecesFromDateIndex.bind(this);
        this.findNextAvailableDate = this.findNextAvailableDate.bind(this);

        this.selectTimeFrame = this.selectTimeFrame.bind(this);
        this.selectFromYear = this.selectFromYear.bind(this);
        this.selectFromMonth = this.selectFromMonth.bind(this);
        this.selectFromDay = this.selectFromDay.bind(this);
        this.selectToYear = this.selectToYear.bind(this);
        this.selectToMonth = this.selectToMonth.bind(this);
        this.selectToDay = this.selectToDay.bind(this);

        this.generateTimeFrameSelector = this.generateTimeFrameSelector.bind(this);

        this.gcManager = new GoalContestManager();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isActive != this.props.isActive) {
            if (!this.props.isActive) {
                this.setState({
                    fromYear: null,
                    fromMonth: null,
                    fromDay: null,
                    toYear: null,
                    toMonth: null,
                    toDay: null
                });
            } else {
                let fromDateObj = this.datePiecesFromDateIndex(this.props.fromDate);
                let toDateObj = this.datePiecesFromDateIndex(this.props.toDate);
                this.setState({
                    fromYear: fromDateObj.year,
                    fromMonth: fromDateObj.month,
                    fromDay: fromDateObj.day,
                    toYear: toDateObj.year,
                    toMonth: toDateObj.month,
                    toDay: toDateObj.day,
                })
            }
        }
    }

    datePiecesFromDateIndex(dateIndex) {
        if (dateIndex === null) {
            return {
                year: null,
                month: null,
                day: null
            }
        }

        let diString = dateIndex + '';

        return {
            year: diString.substring(0, 4),
            month: diString.substring(4, 6),
            day: diString.substring(6, 8)
        }
    }

    findNextAvailableDate(fromYear, fromMonth, fromDay) {

        let result = {
            toYear: null,
            toMonth: null,
            toDay: null,
            toDateIndex: null
        }

        if (fromYear === null || fromMonth === null || fromDay === null) {
            return result;
        }

        let fromDateIndex = fromYear + "" + fromMonth + "" + fromDay;

        let years = this.props.calendarDates[this.props.timeFrame].end;
        let yearsKeys = _.sortBy(Object.keys(years), x => x);
        for (var y = 0; y < yearsKeys.length; y++) {
            let yearsKey = yearsKeys[y];

            if (parseInt(yearsKey) >= parseInt(fromYear)) {

                let months = years[yearsKey];
                let monthsKeys = _.sortBy(Object.keys(months), x => x);

                for (var m = 0; m < monthsKeys.length; m++) {
                    let monthsKey = monthsKeys[m];

                    if (parseInt(yearsKey + "" + monthsKey) >= parseInt(fromYear + "" + fromMonth)) {

                        let days = _.sortBy(months[monthsKey], x => x);

                        for (var d = 0; d < days.length; d++) {
                            let day = days[d];
                            let tmpDateIndex = yearsKey + monthsKey + day;

                            if (parseInt(tmpDateIndex) >= parseInt(fromDateIndex)) {

                                return {
                                    toYear: yearsKey,
                                    toMonth: monthsKey,
                                    toDay: day,
                                    toDateIndex: parseInt(tmpDateIndex)
                                }
                            }
                        }
                    }
                }
            }
        }

        return result;
    }

    selectTimeFrame(timeFrame) {
        let self = this;
        self.setState({ fromYear: null, fromMonth: null, fromDay: null, toYear: null, toMonth: null, toDay: null }, () => {
            self.props.changeFromDate(null);
            self.props.changeToDate(null);
            self.props.changeTimeFrame(timeFrame);
        })
    }

    selectFromYear(year) {
        let self = this;
        let fromMonthList = year != null ? Object.keys(self.props.calendarDates[self.props.timeFrame].start[year]) : [];
        let fromDayList = [];
        if (fromMonthList.length === 1) {
            fromDayList = self.props.calendarDates[self.props.timeFrame].start[year][fromMonthList[0]];
        }

        let fromYear = year;
        let fromMonth = fromMonthList.length === 1 ? fromMonthList[0] : null;
        let fromDay = fromMonthList.length === 1 && fromDayList.length === 1 ? fromDayList[0] : null;

        let toDateIndex = null;
        let toYear = null;
        let toMonth = null;
        let toDay = null;
        if (this.props.autoPickToDate) {
            let autoDateObj = this.findNextAvailableDate(fromYear, fromMonth, fromDay);
            toYear = autoDateObj.toYear;
            toMonth = autoDateObj.toMonth;
            toDay = autoDateObj.toDay;
            toDateIndex = autoDateObj.toDateIndex;
        }
        self.setState({
            fromYear: fromYear,
            fromMonth: fromMonth,
            fromDay: fromDay,
            toYear: toYear,
            toMonth: toMonth,
            toDay: toDay
        }, () => {
            let fromDateIndex = fromMonthList.length === 1 && fromDayList.length === 1 ? parseInt(self.state.fromYear + '' + self.state.fromMonth + '' + self.state.fromDay) : null;
            self.props.changeFromDate(fromDateIndex);
            self.props.changeToDate(toDateIndex);
        });
    }

    selectFromMonth(month) {
        let self = this;
        let fromDayList = self.props.calendarDates[self.props.timeFrame].start[self.state.fromYear][month];

        let fromYear = this.state.fromYear;
        let fromMonth = month;
        let fromDay = fromDayList.length === 1 ? fromDayList[0] : null;

        let toDateIndex = null;
        let toYear = null;
        let toMonth = null;
        let toDay = null;
        if (this.props.autoPickToDate) {
            let autoDateObj = this.findNextAvailableDate(fromYear, fromMonth, fromDay);
            toYear = autoDateObj.toYear;
            toMonth = autoDateObj.toMonth;
            toDay = autoDateObj.toDay;
            toDateIndex = autoDateObj.toDateIndex;
        }
        self.setState({
            fromMonth: fromMonth,
            fromDay: fromDay,
            toYear: toYear,
            toMonth: toMonth,
            toDay: toDay
        }, () => {
            let fromDateIndex = fromDayList.length === 1 ? parseInt(self.state.fromYear + '' + self.state.fromMonth + '' + self.state.fromDay) : null;
            self.props.changeFromDate(fromDateIndex);
            self.props.changeToDate(toDateIndex);
        });
    }

    selectFromDay(day) {
        let self = this;

        let fromYear = this.state.fromYear;
        let fromMonth = this.state.fromMonth;
        let fromDay = day;

        let toDateIndex = null;
        let toYear = null;
        let toMonth = null;
        let toDay = null;
        if (this.props.autoPickToDate) {
            let autoDateObj = this.findNextAvailableDate(fromYear, fromMonth, fromDay);
            toYear = autoDateObj.toYear;
            toMonth = autoDateObj.toMonth;
            toDay = autoDateObj.toDay;
            toDateIndex = autoDateObj.toDateIndex;
        }
        self.setState({
            fromDay: fromDay,
            toYear: toYear,
            toMonth: toMonth,
            toDay: toDay
        }, () => {
            let fromDateIndex = parseInt(self.state.fromYear + '' + self.state.fromMonth + '' + self.state.fromDay);
            self.props.changeFromDate(fromDateIndex);
            self.props.changeToDate(toDateIndex);
        });
    }

    selectToYear(year) {
        let self = this;
        let toMonthList = Object.keys(self.props.calendarDates[self.props.timeFrame].end[year]);
        let toDayList = [];
        if (toMonthList.length === 1) {
            toDayList = self.props.calendarDates[self.props.timeFrame].end[year][toMonthList[0]];
        }

        let toYear = year;
        let toMonth = toMonthList.length === 1 ? toMonthList[0] : null;
        let toDay = toMonthList.length === 1 && toDayList.length === 1 ? toDayList[0] : null;
        let toDateIndex = toMonthList.length === 1 && toDayList.length === 1 ? parseInt(toYear + '' + toMonth + '' + toDay) : null;
        if (this.props.autoPickToDate) {
            let autoDateObj = this.findNextAvailableDate(this.state.fromYear, this.state.fromMonth, this.state.fromDay);
            toYear = autoDateObj.toYear;
            toMonth = autoDateObj.toMonth;
            toDay = autoDateObj.toDay;
            toDateIndex = autoDateObj.toDateIndex;
        }

        self.setState({
            toYear: toYear,
            toMonth: toMonth,
            toDay: toDay,
        }, () => {
            self.props.changeToDate(toDateIndex);
        });
    }

    selectToMonth(month) {
        let self = this;
        let toDayList = self.props.calendarDates[self.props.timeFrame].end[self.state.toYear][month];

        let toYear = this.state.toYear;
        let toMonth = month;
        let toDay = toDayList.length === 1 ? toDayList[0] : null;
        let toDateIndex = toDayList.length === 1 ? parseInt(toYear + '' + toMonth + '' + toDay) : null;
        if (this.props.autoPickToDate) {
            let autoDateObj = this.findNextAvailableDate(this.state.fromYear, this.state.fromMonth, this.state.fromDay);
            toYear = autoDateObj.toYear;
            toMonth = autoDateObj.toMonth;
            toDay = autoDateObj.toDay;
            toDateIndex = autoDateObj.toDateIndex;
        }

        self.setState({
            toYear: toYear,
            toMonth: toMonth,
            toDay: toDay,
        }, () => {
            self.props.changeToDate(toDateIndex);
        });
    }

    selectToDay(day) {
        let self = this;

        let toYear = this.state.toYear;
        let toMonth = this.state.toMonth;
        let toDay = day;
        let toDateIndex = parseInt(toYear + '' + toMonth + '' + toDay);
        if (this.props.autoPickToDate) {
            let autoDateObj = this.findNextAvailableDate(this.state.fromYear, this.state.fromMonth, this.state.fromDay);
            toYear = autoDateObj.toYear;
            toMonth = autoDateObj.toMonth;
            toDay = autoDateObj.toDay;
            toDateIndex = autoDateObj.toDateIndex;
        }

        self.setState({
            toYear: toYear,
            toMonth: toMonth,
            toDay: toDay,
        }, () => {
            self.props.changeToDate(toDateIndex);
        });
    }

    generateTimeFrameSelector(timeFrame) {
        if (!this.props.canChangeTimeFrame) {
            return null;
        }
        return [
            (<div className="gc-question time">{"The time period for my contest is..."}</div>),
            (<div className={"gc-time-text" + (timeFrame === 'day' ? ' active' : '')}>{"Daily"}</div>),
            (<div className={"gc-time-text" + (timeFrame === 'week' ? ' active' : '')}>{"Weekly"}</div>),
            (<div className={"gc-time-text" + (timeFrame === 'month' ? ' active' : '')}>{"Monthly"}</div>),
            (<div className={"gc-time-text" + (timeFrame === 'quarter' ? ' active' : '')}>{"Quarterly"}</div>),
            (<div className={"gc-time-text" + (timeFrame === 'year' ? ' active' : '')}>{"Yearly"}</div>),

            (<div className={"gc-time-button d" + (timeFrame != null ? ' active' : '') + (timeFrame === 'day' ? ' gc-button--active' : '')}
                onClick={this.selectTimeFrame.bind(null, 'day')}>D</div>),
            (<div className={"gc-time-button w" + (timeFrame != null ? ' active' : '') + (timeFrame === 'week' ? ' gc-button--active' : '')}
                onClick={this.selectTimeFrame.bind(null, 'week')}>W</div>),
            (<div className={"gc-time-button m" + (timeFrame != null ? ' active' : '') + (timeFrame === 'month' ? ' gc-button--active' : '')}
                onClick={this.selectTimeFrame.bind(null, 'month')}>M</div>),
            (<div className={"gc-time-button q" + (timeFrame != null ? ' active' : '') + (timeFrame === 'quarter' ? ' gc-button--active' : '')}
                onClick={this.selectTimeFrame.bind(null, 'quarter')}>Q</div>),
            (<div className={"gc-time-button y" + (timeFrame != null ? ' active' : '') + (timeFrame === 'year' ? ' gc-button--active' : '')}
                onClick={this.selectTimeFrame.bind(null, 'year')}>Y</div>)
        ]
    }

    render() {
        let timeFrame = this.props.timeFrame;

        let hideStyle = { opacity: '0', pointerEvents: 'none' };

        let timeIconActiveList = [false, false, false];
        let hideCal = true;
        let hideToFromLabel = true;
        let cardHeight = 10;
        if (timeFrame != null) {
            timeIconActiveList[0] = true;
            hideCal = false;
            hideToFromLabel = false;
            cardHeight = (!this.props.canChangeTimeFrame ? 22.5 : 30.5);
        }
        if (this.props.fromDate != null) {
            timeIconActiveList[1] = true;
        }
        if (this.props.toDate != null) {
            timeIconActiveList[2] = true;
            hideToFromLabel = true;
            cardHeight = (!this.props.canChangeTimeFrame ? 17.5 : 25.5);
        }
        let calendarJsxObj = this.gcManager.generateDateObjects({ timeFrame: timeFrame }, this.props.calendarDates, this);

        let calendarRootClass = "gc-calendar-container" + (!this.props.canChangeTimeFrame ? " move-up" : "");

        let lrPosition = this.props.position < this.props.slideNumber ? '-100vw' : this.props.position > this.props.slideNumber ? '100vw' : '0vw';
        cardHeight = this.props.position === this.props.slideNumber ? cardHeight : 0;

        return (
            <div className={"gc-slide"} style={{ left: lrPosition, overflow: "hidden", height: cardHeight + 'rem' }}>
                <div className={"material-icons gc-time-icon spot1" + (timeIconActiveList[0] ? ' active' : '')}>query_builder</div>
                <div className={"material-icons gc-time-icon spot2" + (timeIconActiveList[1] ? ' active' : '')}>calendar_today</div>
                <div className={"material-icons gc-time-icon spot2" + (timeIconActiveList[1] ? ' active' : '')} style={{ transform: 'rotateY(180deg)' }}>arrow_right_alt</div>
                <div className={"material-icons gc-time-icon spot3" + (timeIconActiveList[2] ? ' active' : '')}>calendar_today</div>
                <div className={"material-icons gc-time-icon spot3" + (timeIconActiveList[2] ? ' active' : '')}>arrow_right_alt</div>

                {this.generateTimeFrameSelector(timeFrame)}

                <div className={"gc-tofrom-label-container" + (!this.props.canChangeTimeFrame ? " move-up" : "")}>
                    <div style={hideToFromLabel ? hideStyle : {}} className={"gc-from-label" + (calendarJsxObj.phase >= 1 && calendarJsxObj.phase < 4 ? ' active' : '')}>{"Start"}</div>
                    <div style={hideToFromLabel ? hideStyle : {}} className={"gc-to-label" + (calendarJsxObj.phase >= 4 && calendarJsxObj.phase < 7 ? ' active' : '')}>{"End"}</div>
                </div>

                <div style={hideCal ? hideStyle : {}} className={calendarRootClass + (calendarJsxObj.phase === 1 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.fromYear}
                </div>
                <div style={hideCal ? hideStyle : {}} className={calendarRootClass + (calendarJsxObj.phase === 2 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.fromMonth}
                </div>
                <div style={hideCal ? hideStyle : {}} className={calendarRootClass + (calendarJsxObj.phase === 3 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.fromDay}
                </div>
                <div style={hideCal ? hideStyle : {}} className={calendarRootClass + (calendarJsxObj.phase === 4 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.toYear}
                </div>
                <div style={hideCal ? hideStyle : {}} className={calendarRootClass + (calendarJsxObj.phase === 5 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.toMonth}
                </div>
                <div style={hideCal ? hideStyle : {}} className={calendarRootClass + (calendarJsxObj.phase === 6 ? ' zup' : '') + (calendarJsxObj.phase === 7 ? ' review' : '')}>
                    {calendarJsxObj.toDay}
                </div>
                <div className={"gc-question calconfirm" + (!this.props.canChangeTimeFrame ? " move-up" : "")} style={calendarJsxObj.phase != 7 ? hideStyle : {}}>
                    {"My contest starts on"}
                </div>
                <div className={"gc-question calconfirm2" + (!this.props.canChangeTimeFrame ? " move-up" : "")} style={calendarJsxObj.phase != 7 ? hideStyle : {}}>
                    {"and ends on"}
                </div>
            </div>
        );
    }
}